import React,{Component} from 'react';
// import {Link} from 'react-router';


const baseAssets = 'https://aquadeals.in/admin/assets/';
class Footer extends Component{
constructor(props){
    super(props);
    this.state={
      showOpenApp: "",
    }
  }
  show_footer(){
    this.setState({ showOpenApp: "close" });
  }
render(){
var footer = '';
if(this.state.showOpenApp === ""){
footer= (

<div className="mob_deals">
    <section className="close_footer">
      <div className="fxd_fotr col-md-12 col-xs-12 col-sm-12">
          <a onClick={this.show_footer.bind(this)} className="cls_btn">
              <img src={baseAssets+'images/web_imgs/close_button.png'} alt=""/>
          </a>
        <p>Download the app to get a much Smoother<br />AquaDeals Experience</p>
              <a className="open_btn" href="https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en" target="_blank">Open app</a>
      </div>
    </section>
  </div>)
}else{
  footer = '';
}
  return (
    <div>
      {footer}
    </div>);
    }
}
export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/Categories/Common/footer.js
 **/